import { ToolPageShell } from '@/shared/seo'
import { SravnitPdfForm } from './SravnitPdfForm'

export function SravnitPdfPage() {
  return (
    <ToolPageShell utilityKey="compare-pdf">
      <SravnitPdfForm />
    </ToolPageShell>
  )
}
